<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <div>
      <el-button icon="el-icon-back" type="primary" size="mini" @click="goBack">
        返回
      </el-button>
      <span class="detail ml-20px">
        <span class="ml-20px text-18px">数据审批</span>
      </span>
    </div>
    <el-row class="h-[calc(100%-38px)] mt-10px" :gutter="20">
      <el-col :span="6" class="h-full border-r-1">
        <div class="h-100px overflow-y-auto">
          <div><span class="border-l-3 border-color-primary pl-10px text-18px">基本信息</span></div>
          <div class="mt-10px text-16px pl-10px" v-loading="baseInfoLoading">
            <div class="truncate mt-10px">批次编号： {{ baseInfo.batchCode }}</div>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="mt-10px"
            @click="goEditPage"
            v-if="baseInfo.approveStatus === 5"
            >编辑</el-button
          >
        </div>
        <div class="mt-20px h-[calc(100%-120px)]">
          <div>
            <span class="border-l-3 border-color-primary pl-10px text-18px">表字段详情</span>
          </div>
          <el-table
            border
            :data="entityList"
            :loading="entityLoading"
            height="calc(100% - 34px)"
            class="mt-10px"
            @row-click="getEntityData"
            ref="entityTableRef"
          >
            <el-table-column show-overflow-tooltip prop="name" label="实体名称"></el-table-column>
            <el-table-column show-overflow-tooltip prop="code" label="实体编码"></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="showWorkFlow ? 12 : 18" class="h-full">
        <div class="h-full w-full" id="gc-designer-box"></div>
      </el-col>
      <el-col :span="6" class="h-full">
        <workflow
          ref="workflow"
          :flowId="baseInfo.flowTaskId"
          :approveStatus="baseInfo.approveStatus"
          :batchId="batchId"
          @close="close"
          @approvalSuccess="getBatchDataInfo"
          v-if="showWorkFlow"
        />
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import DataApprovalService from '@/services/dataApprovalService'
import workflow from './components/workflow'
import defaultJson from '../onlineFilling/defaultJson'

export default {
  name: 'approval',
  components: { workflow },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  data() {
    return {
      entityLoading: false, // 实体列表loading
      entityList: [], // 实体列表数据
      dataLoading: false, // 实体数据列表loading
      dataList: [], // 实体数据列表
      dataPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      }, // 实体数据列表分页
      baseInfo: {
        batchCode: '', // 批次编号
        approveStatus: 0, // 审批状态
        flowTaskId: '', // 流程状态
      },
      baseInfoLoading: false, // 获取批次信息loading
      entityDataTableHeader: [], // 表头
      batchId: '', // 批次id
      currentEntityData: null, // 当前点击项实体
      showWorkFlow: true, // 是否显示工作流程
    }
  },
  created() {
    if (this.$route.query.showWorkFlow === 'false') {
      this.showWorkFlow = false
    }
    // 根据路由中的批次id获取批次基本信息
    this.batchId = this.$route.query.batchId
    if (!this.batchId) return
    this.getBatchDataInfo()
    this.getEntityList()
  },
  mounted() {
    this.initSheet()
  },
  methods: {
    /**
     * @description 获取批次基本信息
     */
    async getBatchDataInfo() {
      this.baseInfoLoading = true
      const res = await DataApprovalService.getBatchInfo({
        id: this.batchId,
      })
      this.baseInfoLoading = false
      if (res && res.data && res.code === 0) {
        this.baseInfo = res.data
      }
    },

    /**
     * @description 获取实体数据列表数据
     */
    async getEntityList() {
      this.entityLoading = true
      const res = await DataApprovalService.getBatchEntity({
        batchId: this.batchId,
      })
      this.entityLoading = false
      if (res && res.data && res.code === 0) {
        this.entityList = res.data
        this.$nextTick(() => {
          this.$refs.entityTableRef?.doLayout()
        })
      }
    },

    /**
     * @description 获取实体数据
     */
    async getEntityData(entityData) {
      this.currentEntityData = { ...entityData }
      await this.getEntityDataHeaderList()
      this.getEntityDataList()
    },

    /**
     * @description 获取实体下数据列表表头
     */
    async getEntityDataHeaderList() {
      if (!this.currentEntityData) return
      this.dataLoading = true
      const res = await DataApprovalService.getDynamicTableHeader({
        classId: this.currentEntityData.id,
      })
      this.dataLoading = false
      if (res && res.data && res.code === 0) {
        this.entityDataTableHeader = res.data
        this.bindCellColumns()
      }
    },

    /**
     * @description 获取实体下数据
     */
    async getEntityDataList() {
      if (!this.currentEntityData) return
      this.dataLoading = true
      const res = await DataApprovalService.getBatchEntityData({
        maxResultCount: this.dataPage.pageSize,
        skipCount: this.dataPage.pageSize * (this.dataPage.pageNo - 1),
        batchId: this.batchId,
        classId: this.currentEntityData.id,
      })
      this.dataLoading = false
      if (res && res.data && res.code === 0) {
        this.dataList = res.data
        this.dataPage.total = res.totalCount
        this.initDataSource()
      }
    },

    /**
     * @description spreadjs单元格数据绑定
     */
    bindCellColumns() {
      const entityDataTableHeader = this.entityDataTableHeader.filter((item) => {
        return item.code !== 'ApproveStatus'
      }) // 移除'审批状态'列
      const sheetsKeys = Object.keys(defaultJson.sheets)
      defaultJson.sheets[sheetsKeys[0]].tables[0].columns = _.map(
        entityDataTableHeader,
        (i, index) => {
          return {
            id: index,
            name: i.name,
            dataField: i.name,
            columnName: i.columnName,
          }
        }
      )
      this.columns = [...entityDataTableHeader]
      defaultJson.sheets[sheetsKeys[0]].tables[0].colCount =
        defaultJson.sheets[sheetsKeys[0]].tables[0].columns.length
      defaultJson.sheets[sheetsKeys[0]].tables[0].bindingPath = this.currentEntityData.name
      defaultJson.sheets[sheetsKeys[0]].columnCount = 100 // 设置列数
      this.sheet = this.spread.getActiveSheet()
      this.spread.fromJSON(defaultJson)
      // this.initDataSource()
    },

    /**
     * @description 初始化数据源
     */
    initDataSource() {
      const entityDataTableHeader = this.entityDataTableHeader.filter((item) => {
        return item.code !== 'ApproveStatus'
      }) // 移除'审批状态'列
      const columnNames = _.map(entityDataTableHeader, (i, index) => {
        return {
          id: index,
          name: i.name,
          dataField: i.name,
          columnName: `${i.tableName}.${i.columnName}`,
        }
      })
      const jsonData = this.spread.toJSON()
      const dataObject = {}
      _.forEach(jsonData.sheets, (sheet) => {
        _.forEach(sheet.tables, (i) => {
          dataObject[i.bindingPath] = []
          _.forEach(this.dataList, (item, index) => {
            dataObject[i.bindingPath][index] = {}
            _.forEach(columnNames, (k) => {
              dataObject[i.bindingPath][index][k.name] = item[k.columnName]
            })
          })
        })
      })
      this.sheet = this.spread.getActiveSheet()
      const source = new GC.Spread.Sheets.Bindings.CellBindingSource(dataObject)
      this.sheet.setDataSource(source)
      this.sheet.options.isProtected = true // 所有单元格禁用编辑

      this.$nextTick(() => {
        // 列宽自适应
        this.spread.suspendPaint()
        const sheetsKeys = Object.keys(defaultJson.sheets)
        const sheet = this.spread.getActiveSheet()
        const columnCount = defaultJson.sheets[sheetsKeys[0]]?.columnCount
        if (columnCount) {
          for (let i = 0; i < columnCount; i += 1) {
            sheet.autoFitColumn(i)
          }
        }
        this.spread.resumePaint()
      })
    },

    /**
     * @description 实体数据列表分页数改变
     */
    dataPageSizeChange() {
      this.dataPage.pageNo = 1
      this.getEntityDataList()
    },

    // 审核完成, 返回列表页
    close(val) {
      if (val) this.goBack()
    },

    /**
     * @description 返回
     */
    goBack() {
      this.$router.go(-1)
    },

    /**
     * @description 跳转到审核数据编辑页面
     */
    goEditPage() {
      this.$router.push({
        path: `${this.basePath}/legacy-resource/data-approval/approval-data-edit`,
        query: {
          batchId: this.batchId,
        },
      })
    },

    initSheet() {
      const config = { ...GC.Spread.Sheets.Designer.DefaultConfig }
      config.ribbon = [] // 工具栏
      const designer = new GC.Spread.Sheets.Designer.Designer(
        document.getElementById('gc-designer-box'),
        config
      )
      this.designer = designer
      this.spread = designer.getWorkbook()
      this.excelIo = new GC.Spread.Excel.IO()
      this.sheet = this.spread.getActiveSheet()
      // this.sheet.options.isProtected = false
      this.sheet
        .getRange(0, 0, this.sheet.getRowCount(), this.sheet.getColumnCount())
        .hAlign(GC.Spread.Sheets.HorizontalAlign.center)
      this.sheet
        .getRange(0, 0, this.sheet.getRowCount(), this.sheet.getColumnCount())
        .vAlign(GC.Spread.Sheets.VerticalAlign.center)
      this.sheet.options.allowUserResize = true
      this.sheet.options.protectionOptions = {
        allowResizeRows: true,
        allowResizeColumns: true,
      }
      this.spread.options.allowContextMenu = false // 禁用右键菜单
      this.sheet.options.isProtected = true // 所有单元格禁用编辑
    },
  },
}
</script>

<style lang="scss" scoped>

.detail {
  border-left: 2px solid #e9e9e9;
}
::v-deep .fileButton {
  display: none;
}

</style>
